// import _ from 'lodash'
const _defaultConfig = {
  customIds: [],
  title: '',
  visible: false,
  isCopy: true,
  isMulti: 0,
  isPackageQuality: false,
  isDownloadLimit: false,
  canMintegralPush: false,
  isRating: false
}

const downloadDialog = {
  namespaced: true,

  state: {
    downloadConfig: _defaultConfig
  },

  mutations: {
    updateDownloadConfig: (state, value) => {
      state.downloadConfig = {
        ...state.downloadConfig,
        ...value
      }
    },
    resetDownloadConfig: (state, value) => {
      state.downloadConfig = {
        ...state.downloadConfig,
        ..._defaultConfig
      }
    }
  },

  actions: {
    showDownloadDialog({ commit }, opt) {
      commit('updateDownloadConfig', {
        visible: true,
        ...opt
      })
    },
    closeDownloadDialog({ commit }, opt) {
      commit('resetDownloadConfig')
    }
  }
}

export default downloadDialog
